import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { ThemeMenuIcon } from 'components/ThemeMenuIcon/ThemeMenuIcon';
import { usePlayerLayout } from 'lib/playerLayout';
import styles from './CasinoTabs.module.css';

const TABS = [
  { to: '/casino-games', label: 'casino_games_label', icon: 'casino-games' },
  { to: '/live-casino', label: 'live_casino_label', icon: 'live-casino' },
] as const;

/** Casino / Live casino switch at the top of the modern-layout lobby. */
export function CasinoTabs() {
  const url = useLocation().pathname;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const layout = usePlayerLayout();
  if (layout !== 'modern') return null;
  return (
    <div className={styles.tabs}>
      {TABS.map((tab) => (
        <button
          type="button"
          key={tab.to}
          className={classNames(styles.tab, url === tab.to && styles.active)}
          onClick={() => navigate(tab.to, { replace: true })}
        >
          <ThemeMenuIcon icon={tab.icon} alt="" variant="footer" />
          {t(tab.label)}
        </button>
      ))}
    </div>
  );
}
